import { GameCardConfigBase } from "kadow-jetpack-model";
import React, { FC } from "react";
import styles from "./GameCard.module.scss";
import { LANGUAGE } from "../../utils/i18n/i18n";
import TwemojiWrapper from "../../components/TwemojiWrapper/TwemojiWrapper";

export interface GameCardProps {
  gameCardConfig: GameCardConfigBase;
  eventId: string;
}

/**
 * Width and height are in the CSS code.
 * @param props
 * @constructor
 */
const GameCard: FC<GameCardProps> = (props) => {
  //console.log(props.eventId, JSON.stringify(props.gameCardConfig, null, 2));
  return (
    <div className={styles.gameCardWrapper}>
      <img
        className={[styles.gameCardBackground, "twic"].join(" ")}
        data-src={`image:/cdm/jetpack/skins/${props.eventId}/${
          props.gameCardConfig?.background.url
        }`}
        style={props.gameCardConfig?.background.style}
      />
      <div className={styles.logoContainer}>
        <span
          className={styles.gameCardWrapperSpan}
          style={props.gameCardConfig?.title.style}
        >
          {props.gameCardConfig?.title.content[LANGUAGE]}
        </span>
        {!!props.gameCardConfig?.title.emoji && (
          <span style={props.gameCardConfig?.title.emojiStyle}>
            <TwemojiWrapper className={"cardEmoji"}>
              {props.gameCardConfig?.title.emoji}
            </TwemojiWrapper>
          </span>
        )}
      </div>
      <div className="innerWrapper">
        <div className="right"></div>
      </div>
    </div>
  );
};

export default GameCard;
